module.exports = __webpack_public_path__ + "static/media/AICS.57175f4c.png";